$(document).ready(function () {
    $('body').on('click', '.open-department', function (e) {
        e.preventDefault();
        var url = $(this).data('actionurl');
        var redirectLink = this.href;
        $.ajax({
            url: url,
            type: 'get',
            success: function () {
               window.location.href = redirectLink;
            }
        });
    });
});
